import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import StepDetail from './StepDetail';
import PreopInstructionsModal from './PreopInstructionsModal';
import { Description } from './StepDetail';
import { YellowButton } from '../../../components/Buttons';
import { ReactComponent as StopIcon } from '../../../assets/icons/stop.svg';

const TRIGGER_INSTRUCTION = gql`
  query triggerInstruction {
    journeyType

    triggerInstruction {
      id
      instructions

      triggerDrug {
        name
        trigger
        amount
        id
      }
    }
  }
`;

const TriggerInjectionDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const { loading, data } = useQuery(TRIGGER_INSTRUCTION);

  if (loading || !data) {
    return null;
  }
  const { triggerInstruction, journeyType } = data;
  if (!triggerInstruction || !triggerInstruction.instructions) {
    const isIUIOrTI = journeyType === 'IUI' || journeyType === 'TIMED INTERCOURSE';
    return (
      <>
        <StepDetail>
          <FlexContainer>
            <Description>
              {isIUIOrTI
                ? "You will be provided with the specific medication that's right for you as well as a window when to take it."
                : "You will be provided with the specific medication that's right for you as well as a specific time to inject it. This will be 35 hours before your retrieval procedure. It's extremely important you are precise about this."}
            </Description>
            {!isIUIOrTI ? (
              <Button onClick={() => setShowModal(!showModal)}>Review Pre-Op Instructions</Button>
            ) : null}
          </FlexContainer>
        </StepDetail>
        <PreopInstructionsModal show={showModal} hide={() => setShowModal(false)} />
      </>
    );
  }
  const {
    triggerDrug: { name },
    instructions
  } = triggerInstruction;

  return (
    <>
      <StepDetail>
        <FlexContainer>
          <div>
            <strong>{name}</strong>
            <Description>{instructions}</Description>
          </div>
          <Button onClick={() => setShowModal(!showModal)}>Review Pre-Op Instructions</Button>
        </FlexContainer>
      </StepDetail>
      <Warning>
        <IconWrapper>
          <StopIcon />
        </IconWrapper>
        <strong>Be sure to discontinue your stimulation medications</strong>
      </Warning>
      <PreopInstructionsModal show={showModal} hide={() => setShowModal(false)} />
    </>
  );
};

export default TriggerInjectionDetail;

const Warning = styled.p`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  align-items: center;
  cursor: default;
  display: flex;
`;

const IconWrapper = styled.span`
  margin-right: 5px;
`;

const FlexContainer = styled.div`
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.smallDesktop}) {
    flex-wrap: wrap;
  }
`;

const Button = styled(YellowButton)`
  min-width: fit-content;
  height: fit-content;
`;
